import React from 'react';

import styled from 'styled-components';

import theme from './theme';

interface INullPictureFallback {
  width?: string;
  height?: string;
  fontSize?: string;
}

const Wrapper = styled.div<INullPictureFallback>`
  background-color: ${Styles.color.grey.four};
  border-radius: inherit;
  height: ${p => p.height || '80px'};
  width: ${p => p.width || '106px'};
  color: ${theme.wrapperColor};
  font-size: ${p => p.fontSize || '1rem'};
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
`;

const NullImageFallBack: React.FC<INullPictureFallback> = props => (
  <Wrapper {...props}>No Image</Wrapper>
);

export default NullImageFallBack;
